export const inventoryData = [
  {
    id: 1,
    vin: "1HGBH41JXMN109186",
    make: "Toyota",
    model: "Camry",
    year: 2022,
    trim: "XSE",
    stock: "T22054",
    mileage: 12500,
    price: 25999,
    type: "sedan",
    color: "Midnight Black",
    fuelType: "Gasoline",
    transmission: "Automatic",
    engine: "2.5L 4-Cylinder",
    features: [
      "Backup Camera",
      "Bluetooth",
      "Apple CarPlay",
      "Android Auto",
      "Keyless Entry",
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/blue-car-driving-road_114579-4056.jpg",
  },
  {
    id: 2,
    vin: "5YJSA1E47MF123456",
    make: "Honda",
    model: "CR-V",
    year: 2021,
    trim: "EX-L",
    stock: "H21087",
    mileage: 18200,
    price: 27500,
    type: "suv",
    color: "Modern Steel",
    fuelType: "Gasoline",
    transmission: "CVT",
    engine: "1.5L Turbo 4-Cylinder",
    features: [
      "Leather Seats",
      "Sunroof",
      "Power Liftgate",
      "Heated Seats",
      "Lane Assist",
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/blue-suv-parking-public-area_114579-4042.jpg",
  },
  {
    id: 3,
    vin: "1FTFW1ET5MFA28956",
    make: "Ford",
    model: "F-150",
    year: 2023,
    trim: "Lariat",
    stock: "F23112",
    mileage: 5000,
    price: 42000,
    type: "truck",
    color: "Velocity Blue",
    fuelType: "Gasoline",
    transmission: "10-Speed Automatic",
    engine: "3.5L EcoBoost V6",
    features: [
      "Navigation",
      "Tow Package",
      "Blind Spot Monitor",
      "Pro Trailer Backup Assist",
      "Heated Steering Wheel",
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/pickup-truck-parked-countryside_114579-4049.jpg",
  },
  {
    id: 4,
    vin: "5YJ3E1EA8LF123789",
    make: "Tesla",
    model: "Model 3",
    year: 2022,
    trim: "Long Range",
    stock: "TE22043",
    mileage: 8700,
    price: 45990,
    type: "electric",
    color: "Pearl White",
    fuelType: "Electric",
    transmission: "Single-Speed",
    engine: "Dual Motor AWD",
    features: [
      "Autopilot",
      "Premium Interior",
      "Glass Roof",
      "Heated Seats",
      '15" Touchscreen',
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/white-electric-car-charging-station_114579-4114.jpg",
  },
  {
    id: 5,
    vin: "WBA5R7C53KAJ78234",
    make: "BMW",
    model: "3 Series",
    year: 2021,
    trim: "330i xDrive",
    stock: "B21076",
    mileage: 22000,
    price: 39500,
    type: "luxury",
    color: "Alpine White",
    fuelType: "Gasoline",
    transmission: "8-Speed Automatic",
    engine: "2.0L TwinPower Turbo",
    features: [
      "Premium Package",
      "Driver Assistance Package",
      "Harman Kardon Sound",
      "Leather Interior",
      "Navigation",
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/white-premium-sedan-car-road_114579-4060.jpg",
  },
  {
    id: 6,
    vin: "3GNAXUEV2ML345621",
    make: "Chevrolet",
    model: "Equinox",
    year: 2023,
    trim: "Premier",
    stock: "C23029",
    mileage: 3200,
    price: 28790,
    type: "suv",
    color: "Cajun Red",
    fuelType: "Gasoline",
    transmission: "6-Speed Automatic",
    engine: "1.5L Turbo",
    features: [
      "Remote Start",
      "Wifi Hotspot",
      "Power Liftgate",
      "Leather Seats",
      "Bose Audio",
    ],
    imageUrl: "https://img.freepik.com/free-photo/red-suv-road_114579-4080.jpg",
  },
  {
    id: 7,
    vin: "JN8AT2MT5LW123476",
    make: "Nissan",
    model: "Rogue",
    year: 2022,
    trim: "SL",
    stock: "N22119",
    mileage: 15600,
    price: 29450,
    type: "suv",
    color: "Glacier White",
    fuelType: "Gasoline",
    transmission: "CVT",
    engine: "2.5L 4-Cylinder",
    features: [
      "ProPilot Assist",
      "Panoramic Moonroof",
      "Bose Audio",
      "Around View Monitor",
      "Heated Seats",
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/white-suv-parked-beach_114579-4062.jpg",
  },
  {
    id: 8,
    vin: "1G1ZD5ST3LF134562",
    make: "Chevrolet",
    model: "Malibu",
    year: 2021,
    trim: "LT",
    stock: "C21098",
    mileage: 24300,
    price: 22750,
    type: "sedan",
    color: "Silver Ice Metallic",
    fuelType: "Gasoline",
    transmission: "CVT",
    engine: "1.5L Turbo",
    features: [
      "Rear Vision Camera",
      "Android Auto",
      "Apple CarPlay",
      "Remote Start",
      "Heated Seats",
    ],
    imageUrl:
      "https://img.freepik.com/free-photo/silver-sedan-parked-lot_114579-4070.jpg",
  },
];

export default inventoryData;
